export const PERIOD = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
  HIGH: 'high',
};

export const UNIT = {
  [PERIOD.DAY]: 'hour',
  [PERIOD.WEEK]: 'day',
  [PERIOD.MONTH]: 'day',
  [PERIOD.QUARTER]: 'month',
  [PERIOD.YEAR]: 'month',
  [PERIOD.HIGH]: 'year',
};

export const SYMBOL_BY_PERIOD = {
  [PERIOD.DAY]: '1 D',
  [PERIOD.WEEK]: '1 W',
  [PERIOD.MONTH]: '1 M',
  [PERIOD.QUARTER]: '3 M',
  [PERIOD.YEAR]: '1 Y',
  [PERIOD.YEAR]: '1 Y',
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/constants/period.js